import Vue from "vue";
import iView from "view-design";
import Clipboard from "clipboard";
let token = "";

// 作者端地址
let getBaseUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("localhost") != -1 || location.host.indexOf("8088") != -1
  ) {
    // url="http://47.93.50.49:8092/tsg-author"
    url = "https://tsgauthortest.baikezaixian.com/tsg-author"; // 测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    // url = "http://112.126.62.29:8092/tsg-author"; // 预生产环境
    url="https://tsgauthoryu.cnknowledge.com/tsg-author"
  } else {
    url = "https://tsgauthor.cnknowledge.com/tsg-author"; // 正式环境
  }
  return url;
};

// 中文知识网地址
let getCnkUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("localhost") != -1 || location.host.indexOf("8088") != -1
  ) {
    // url="http://47.93.50.49:5052"
    url = "https://wxtest.cnknowledge.com"; // 测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    // url = "http://112.126.62.200:5052"; // 预生产环境
    url="https://zwiii.cnknowledge.com"
  } else {
    url = "https://zwi.cnknowledge.com"; // 正式环境
  }
  return url;
};

// url4
let getUrl4 = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("localhost") != -1 || location.host.indexOf("8088") != -1
  ) {
    //http://47.93.50.49:5052
    url = "https://wxtest.cnknowledge.com/"; // 测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    // url = "http://112.126.62.200:5052/"; // 预生产环境
    url="https://zwiii.cnknowledge.com/"
  } else {
    url = "https://zwi.cnknowledge.com/"; // 正式环境
  }
  return url;
};

// 图片地址
let getImgUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("localhost") != -1 || location.host.indexOf("8088") != -1
  ) {
    url = "https://fdfs.cnknowledge.com/"; // 测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    url = "https://ljw.cnknowledge.com/"; // 预生产环境
  } else {
    url = "https://kpp.cnknowledge.com/"; // 正式环境
  }
  return url;
};

// 投审稿登录
let getWebUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("localhost") != -1 || location.host.indexOf("8088") != -1
  ) {
    url = "https://dev.cnknowledge.com/newtsgweb/#/loginAdmin"; // 测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    url = "https://yutsg.cnknowledge.com/newtsgweb/#/loginAdmin"; // 预生产环境
  } else {
    url = "https://publish.cnknowledge.com/newtsgweb/#/loginAdmin"; // 正式环境
  }
  return url;
};
// 投审稿
let tsgUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("localhost") != -1 || location.host.indexOf("8088") != -1
  ) {
    url = "https://dev.cnknowledge.com/newtsgweb/"; // 测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    url = "https://yutsg.cnknowledge.com/newtsgweb/"; // 预生产环境
  } else {
    url = "https://publish.cnknowledge.com/newtsgweb/"; // 正式环境
  }
  return url;
};
// 百科在线
let bkzxUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("localhost") != -1 || location.host.indexOf("8088") != -1
  ) {
    url = "http://dev.cnknowledge.com/bkzxweb/"; // 测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    url = "http://yu.baikezaixian.com/bkzxweb/"; // 预生产环境
  } else {
    url = "http://publish.cnknowledge.com/bkzxweb/"; // 正式环境
  }
  return url;
}; //
// 中文知识网
let zwUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("localhost") != -1 || location.host.indexOf("8088") != -1
  ) {
    url = "https://test.cnknowledge.com/"; // 测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    url = "https://yu.cnknowledge.com/"; // 预生产环境
  } else {
    url = "https://www.cnknowledge.com/"; // 正式环境
  }
  return url;
};
let getParam = function getParam() {
  var search = {};
  try {
    location.search
      .substr(1)
      .split("&")
      .forEach(function(item) {
        var s = item.split("=");
        search[s[0]] = s[1];
      });
  } catch (e) {
    // 抛出异常
    throw new Error(JSON.stringify(search));
  }
  return search;
};
token = getParam().token;
//sessionStorage.setItem('perId', getParam().perId);
var global = {
  url: getBaseUrl(),
  //	url:location.host.indexOf("dev.") != -1||location.host.indexOf(":80") != -1?'https://tsgauthor.cnknowledge.com/tsg-author':'http://47.93.50.49:8092/tsg-author',
  url2: "https://web.tonghangpingyi.com/txpy-web",
  url3: getCnkUrl(),
  //url:location.host.indexOf("dev.") != -1||location.host.indexOf(":80") != -1? "http://dev.cnknowledge.com:8081/tsg":"http://pubadmin.cnknowledge.com/tsg",
  imgUrl: getImgUrl(),
  url4: getUrl4(),
  webUrl: getWebUrl(),
  tsgUrl: tsgUrl(),
  bkzxUrl: bkzxUrl(),
  zwUrl: zwUrl(),
  perId: getParam().prid,
  publishPeriod(num) {
    let data = [
      { name: "年刊" },
      { name: "半年刊" },
      { name: "季刊" },
      { name: "双月刊" },
      { name: "月刊" },
      { name: "半月刊" },
      { name: "旬刊" },
      { name: "周刊" },
      { name: "周二刊" },
    ];
    if (num == "") {
      return;
    }
    return data[num - 1].name;
  },
  isPC() {
    return !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  },
  //js根据对象数组中某一属性删除该项（根据数组对象属性删除里面的对象）
  removes(val) {
    var index = this.indexOf(val);
    if (index > -1) {
      this.splice(index, 1);
    }
  },
  //深拷贝
  deepClone(obj) {
    let _tmp = JSON.stringify(obj); //将对象转换为json字符串形式
    let result = JSON.parse(_tmp); //将转换而来的字符串转换为原生js对象
    return result;
        
    // let cloneObj = Array.isArray(obj) ? [] : {};
    // if (obj && typeof obj === "object") {
    //   for (const key in obj) {
    //     if (key === "timeArr") {
    //       console.log(obj[key]);
    //     }
    //     if (obj.hasOwnProperty(key)) {
    //       if (obj[key] && typeof obj[key] === "object") {
    //         cloneObj[key] = this.deepClone(obj[key]);
    //       } else {
    //         cloneObj[key] = obj[key];
    //       }
    //     }
    //   }
    // }
    // return cloneObj;
  },
  // 对比两个对象的值是否完全相等 返回值 true/false
  isObjectValueEqual(a, b, c) {
    //取对象a和b的属性名
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    //判断属性名的length是否一致
    // if (aProps.length != bProps.length) {
    //     return false;
    // }
    //循环取出属性名，再判断属性值是否一致
    for (var i = 0; i < aProps.length; i++) {
      if (aProps[i] == "level") {
        aProps.splice(i, 1);
        bProps.splice(i, 1);
      }
      if (bProps[i] == "level") {
        bProps.splice(i, 1);
      }
    }
    for (var i = 0; i < aProps.length; i++) {
      if (aProps[i] == "id") {
        aProps.splice(i, 1);
      }
      if (bProps[i] == "id") {
        bProps.splice(i, 1);
      }
    }
    for (var i = 0; i < aProps.length; i++) {
      if (aProps[i] == "__ob__") {
        aProps.splice(i, 1);
      }
      if (bProps[i] == "__ob__") {
        bProps.splice(i, 1);
      }
    }
    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];
      if (a[propName] != b[propName]) {
        return false;
      }
    }
    return true;
  },
  //稿件状态
  articleStatus(status) {
    switch (status) {
      case 0:
        status = "未完成";
        break;
      case 1:
        status = "初审分配";
        break;
      case 10:
        status = "初审";
        break;
      case 15:
        status = "筛稿分配";
        break;
      case 16:
        status = "筛稿";
        break;
      case 20:
        status = "查重";
        break;
      case 30:
        status = "复审分配";
        break;
      case 40:
        status = "复审";
        break;
      case 50:
        status = "外审分配";
        break;
      case 60:
        status = "外审";
        break;
      case 65:
        status = "终审分配";
        break;
      case 70:
        status = "终审";
        break;
      case 80:
        status = "录用确认";
        break;
      case 90:
        status = "录用";
        break;
      case 100:
        status = "排期";
        break;
      case 110:
        status = "发排";
        break;
      case 120:
        status = "初排";
        break;
      case 130:
        status = "一校";
        break;
      case 140:
        status = "一改";
        break;
      case 150:
        status = "二校";
        break;
      case 160:
        status = "二改";
        break;
      case 170:
        status = "三校";
        break;
      case 180:
        status = "三改";
        case 181:
          status = "四校";
        break;
        case 182:
          status = "四改";
        break;
        case 183:
          status = "五校";
        break;
        case 184:
          status = "五改";
        break;
        case 185:
          status = "六校";
        break;
        case 186:
          status = "六改";
        break;
        case 187:
          status = "七校";
        break;
        case 188:
          status = "七改";
        break;
        case 189:
          status = "八校";
        break;
        case 191:
          status = "八改";
          break;
        break;
      case 190:
        status = "出片";
        break;
      case 200:
        status = "改片";
        break;
      // 2023/11 增加校样功能
        case 205:
          status = "确认校样";
        break;
      // v3.0.6 增加付印节点，作者端 付印和印刷统一展示位印刷
        case 209:
          status = "印刷";
          break;
      case 210:
        status = "印刷";
        break;
      case 220:
        status = "邮寄";
        break;
      case 230:
        status = "已刊发";
        break;
      case 240:
        status = "存档";
        break;
      case 300:
        status = "退修";
        break;
      case 350:
        status = "退修中";
        break;
      case 400:
        status = "退稿";
        break;
      case 450:
        status = "退稿中";
        break;
    }
    return status;
  },
  //职称
  gradess(status) {
    if (status == "senior") {
      return "1";
    } else if (status == "subSenior") {
      return "2";
    } else if (status == "middle") {
      return "3";
    } else if (status == "elementary") {
      return "4";
    }
  },
  //开票状态
  invoiceStatus(status) {
    let data = [
      {
        name: "未开发票",
      },
      {
        name: "待开票",
      },
      {
        name: "已开发票",
      },
      {
        name: "需要未开",
      },
      {
        name: "无需开票",
      },
      {
        name: "过期未开",
      },
      {
        name: "已处理",
      },
    ];
    return data[status - 1].name;
  },
  //基金类型
  found(type) {
    let data = [
      {
        name: "国际级",
      },
      {
        name: "国家级",
      },
      {
        name: "省级",
      },
      {
        name: "市、院、校级",
      },
      {
        name: "县级及其他",
      },
    ];
    return data[type - 1].name;
  },
  //支付方式
  feeType(status) {
    if (status == "WXPay") {
      status = "微信";
    } else if (status == "Alipay 2.0") {
      status = "支付宝";
    } else if (status == "ACP") {
      status = "银联闪付";
    } else {
      status = "无";
    }
    return status;
  },
  getParam: getParam, // 获取url参数返回json
  checkPhone(value) {
    //验证手机号
    if (value == "") {
      iView.Message.destroy();
      iView.Message.warning("手机号不能为空");
      return false;
    }
    if (!/^1[3456789]\d{9}$/.test(value)) {
      iView.Message.destroy();
      iView.Message.warning("手机号格式不对");
      return false;
    }
    return true;
  },
  transferDate(times) {
    //时间戳转时间
    var date = new Date(times);
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    var s =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
  },
  transferYear(times) {
    //时间戳转时间年月日
    var date = new Date(times);
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  },
  getYear(times) {
    //时间戳转时间年月
    if (!times) return "";
    var date = new Date(times);
    var Y = date.getFullYear();
    return String(Y);
  },
  transferMonth(times) {
    //时间戳转时间年月
    var date = new Date(times);
    var Y = date.getFullYear() + "-";
    var M =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    return Y + M;
  },
  transferTime(times) {
    //时间转时间戳
    return new Date(times).getTime();
  },
  copyArr(arr) {
    //拷贝数组
    return Object.assign([], arr);
  },
  copyObj(obj) {
    //拷贝对象
    return Object.assign({}, obj);
  },
  copy(mobile) {
    var Url = mobile;
    var clipboard = new Clipboard(".tag-read", {
      text: function() {
        return Url;
      },
    });
    clipboard.on("success", (e) => {
      iView.Message.success("复制成功");
      // 释放内存
      clipboard.destroy();
    });
    clipboard.on("error", (e) => {
      // 不支持复制
      iView.Message.destroy();
      iView.Message.warning("该浏览器不支持自动复制");
      // 释放内存
      clipboard.destroy();
    });
  },
  getGradeName(gradeId) {
    if (gradeId == 7) {
      return "初一";
    }
    if (gradeId == 8) {
      return "初二";
    }
    if (gradeId == 9) {
      return "初三";
    }
  },
  sortByKey(array, key) {
    //(数组、排序的列)
    return array.sort(function(a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  },
  // 保存用户信息
  saveUserInfo(info) {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo")); //取出sesion
    userInfo.info = info;
    var jsonStr = JSON.stringify(userInfo);
    sessionStorage.setItem("userInfo", jsonStr); //将用户信息存入sesion
  },
};

// 注册插件全局通用
export default {
  install() {
    Vue.prototype.$global = global;
  },
  global,
};



// WEBPACK FOOTER //
// ./src/core/global/global.js